/* eslint-disable arrow-body-style */
/* eslint-disable prettier/prettier */
import { pathOr } from 'ramda';
import moment from 'moment';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Box, Center, Divider, Flex, Image, HStack, Stack } from '../components/ui';
import backgroundImage from '../../../assets/images/stack-bg.png';
import '../../../assets/images/StackTeam_White@1x.svg';
import sportsConnectLogo from '../../../assets/images/Sports_Connect_powered by_logo_white.png';
import Link from '../../common/components/Link';
import { mediaSizes, theme } from '../../../utils/styles';
import InvalidClient from '../components/invalid-client';

const Wrapper = styled(Flex)`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  background-color: ${theme.lightGray};
  ${mediaSizes.xs(`
    background-color: #fff;
  `)};
`;
const LogoContainer = styled(Center)`
  flex: 0 0 auto;
  width: 100%;
  height: 8em;
  max-width: 80%;
  ${mediaSizes.sm(`
    height: 16em;
    max-width: 34em;
  `)};
  ${mediaSizes.lg(`
    height: 16em;
    max-width: 34em;
  `)};
`;
const LogoContainerInner = styled(Center)`
  margin-top: 1em;
  ${mediaSizes.md(`
    height: 2em;
  `)} ${mediaSizes.lg(`
    height: 2em;
  `)};
`;
const ImageContainer = styled(Image)`
  max-width: 100%;
  ${mediaSizes.lg(`
    max-width: 100%;
  `)};
`;

const WhiteBox = styled(Flex)`
  flex: 1;
  background: #fff;
  width: 100%;
  max-height: 38em;
  ${mediaSizes.sm(`
    flex: 0 0 auto;
    min-height: 37em;
    width: 30em;
  `)}
  ${mediaSizes.md(`
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),0 2px 4px -1px rgba(0, 0, 0, 0.06);
  `)}
  ${mediaSizes.lg(`
    width: 30em;
    margin-bottom: 5em;
  `)}
`;

const Footer = styled(Center)`
  flex: 0 0 auto;
  background: ${theme.footer};
  width: 100%;
  height: auto;
  min-height: auto;
  margin-top: auto;
  font-size: 0.8rem;
  padding-bottom: 0.7em;
  color: white;
  text-align: center;
  ${mediaSizes.md(`
    font-size: 1rem
  `)} padding-top: .7em;
`;

const Main = ({ client, children, error }) => {
  const logoUrl = useMemo(
    () => {
      let url = pathOr(sportsConnectLogo, ['meta', 'logoUrl'], client);
      if (url === '') {
        url = sportsConnectLogo;
      }
      return url;
    },
    [client]
  );
  return (
    <Wrapper
      style={{
        background: `url(${backgroundImage}) 50% -480px repeat-x`
      }}
    >
      {client && (
        <LogoContainer>
          <LogoContainerInner>
            <ImageContainer
              src={logoUrl}
              maxW={['80%', '80%', '80%', '100%']}
              alt="Application Logo"
            />
          </LogoContainerInner>
        </LogoContainer>
      )}
      {client && <WhiteBox>{children}</WhiteBox>}
      {!client && error && <InvalidClient>{children}</InvalidClient>}
      <Footer>
        <Stack spacing={0}>
          <Box>
            &copy; Copyright 2012 - {moment().format('YYYY')} Stack Sports - All Rights Reserved
          </Box>
          <HStack>
            <Box>
              <Link to="https://stacksports.com/legal-privacy" target="_blank" color="white">
                Privacy Policy
              </Link>
            </Box>
            <Divider orientation="vertical" h="1em" />
            <Box>
              <Link to="https://stacksports.com/legal-terms" target="_blank" color="white">
                Terms of Service
              </Link>
            </Box>
            <Divider orientation="vertical" h="1em" />
            <Box>
              <Link to="https://stacksports.com/legal-coppa" target="_blank" color="white">
                Children’s Policy
              </Link>
            </Box>
            <Divider orientation="vertical" h="1em" />
            <Box>
              SLA:{' '}
              <Link
                to="https://stacksports.com/stack-sports-system-license-agreement-united-states"
                target="_blank"
                color="white"
              >
                (US)
              </Link>{' '}
              <Link
                to="https://stacksports.com/stack-sports-system-license-agreement-canada"
                target="_blank"
                color="white"
              >
                (CANADA)
              </Link>
            </Box>
          </HStack>
        </Stack>
      </Footer>
    </Wrapper>
  );
};

export default Main;



// WEBPACK FOOTER //
// ./src/views/sports-connect/layouts/main.js